import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import AboutUsPage from '../AboutUsPage/AboutUsPage';
import PricingPage from '../PricingPage/PricingPage';
import PortfolioPage from '../PortfolioPage/PortfolioPage';
import PortfolioSinglePage from '../PortfolioSinglePage/PortfolioSinglePage';
import TeamPage from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import ServicePage from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import ContactPage from '../ContactPage/ContactPage';
import CaseStudy from '../CaseStudy/CaseStudy';
import BlogList from '../BlogList/BlogList';
import Guides from '../Guides/Guides';
import SaasAiSeo from '../SaasAiSeo/SaasAiSeo';
import SRJ from '../SRJ/srj';
import Nicolas from '../Nicolas/Nicolas';
import Farmoduct from '../Farmoduct/Farmoduct';
import George from '../George/George';
import Arrowdifter from '../Arrowdifter/Arrowdifter';
import EaseMyHotel from '../EaseMyHotel/EaseMyHotel';
import AromaMonk from '../AromaMonk/AromaMonk';
import Elise from '../Elise/Elise';
import GNC from '../GNC/GNC';
import B2BAiSeo from '../B2BAISEO /B2BAiSeo';
import Customaiseosolution from '../CustomAISEOSolution/custom-ai-seo-solution';
import Testimonials from '../Testimonials/testimonials';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage3 />} />
          <Route path="home" element={<Homepage />} />
          <Route path="home_software_company" element={<HomePage2 />} />
          <Route path="home_business_consulting" element={<HomePage3 />} />
          <Route path="about" element={<AboutUsPage />} />
          <Route path="testimonials" element={<Testimonials />} />
          <Route path="casestudy" element={<CaseStudy />} />
          <Route path="bloglist" element={<BlogList />} />
          <Route path="guides" element={<Guides />} />
          <Route path="sasaiseo" element={<SaasAiSeo />} />
          <Route path="b2b-ai-seo" element={<B2BAiSeo />} />
           <Route path="custom-ai-seo-solution" element={<Customaiseosolution />} />
          <Route path="srj" element={<SRJ />} />
          <Route path="nicolas" element={<Nicolas />} />
          <Route path="farmoduct" element={<Farmoduct />} />
          <Route path="george" element={<George />} />
          <Route path="arrowdifter" element={<Arrowdifter />} />
          <Route path="easemyhotel" element={<EaseMyHotel />} />
          <Route path="aromamonk" element={<AromaMonk />} />
          <Route path="elise" element={<Elise />} />
          <Route path="gnc" element={<GNC />} />
          <Route path="pricing" element={<PricingPage />} />
          <Route path="portfolio" element={<PortfolioPage />} />
          <Route path="portfolio_details/:slug" element={<PortfolioSinglePage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="team-single/:slug" element={<TeamSinglePage />} />
          <Route path="service" element={<ServicePage />} />
          <Route path="service-single/:slug" element={<ServiceSinglePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />
          <Route path="contact" element={<ContactPage />} />  
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
